module.exports = __webpack_public_path__ + "_app/media/bg.b5dcf306.mp4";